export default __webpack_public_path__ + "static/media/step-results.7d9b56f5.svg";